export default __webpack_public_path__ + "static/media/iconPaymentCash.a56ef216.svg";